import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { cleanImageUrl } from '../../util/urlUtils';

const $ = window.$;

const DEFAULT_THUMB = 'images/blankImageReplaceable.png';

const SavedItemContainer = styled.div`
  flex: 0 1;
  margin: 0.5rem;
  max-width: 48%;
  flex-basis: 48%;
`;

const SavedItemContent = styled.button`
  display: flex;
  flex-flow: row nowrap;
  line-height: normal;
  width: 100%;

  &.selected {
    transition: all 100ms ease-out;
    background: #509bfe;
    color: white;
  }
`;

const Column = styled.div`
  flex: 1;
  flex-basis: calc(50% - 0.5rem);
`;

const DetailsContainer = styled.div`
  margin-left: 0.5rem;
  flex-flow: column nowrap;
  font-size: 11px;
  justify-items: flex-start;
`;

const Detail = styled.div`
  display: flex;
  margin-bottom: ${props => (props.noMargin ? '0' : '0.5rem')};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

const Thumbnail = styled.img`
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  background-color: grey;
`;

class SavedItem extends Component {
  constructor() {
    super();

    this.state = {
      error: false
    };
  }

  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  handleError = () => {
    this.setState({ error: true });
  };

  addListeners = () => {
    $(this.button)
      .on('click', this.handleAssetClick)
      .on('dblclick', this.handleAssetDoubleClick);
  };

  handleAssetClick = event => {
    event.preventDefault();
    const id = this.props.id;
    this.props.onClick({
      id
    });
  };

  handleAssetDoubleClick = event => {
    event.preventDefault();
    const id = this.props.id;
    this.props.onDoubleClick({
      id
    });
  };

  removeListeners = () => {
    $(this.button).off('dblclick', this.handleAssetDoubleClick);
  };

  render() {
    const { thumbnailUrl, title, abstract, selected } = this.props;
    return (
      <SavedItemContainer>
        <SavedItemContent className={selected ? 'selected' : ''} ref={r => (this.button = r)}>
          <Column>
            <Thumbnail
              onError={this.handleError}
              src={this.state.error ? DEFAULT_THUMB : cleanImageUrl(thumbnailUrl)}
            />
          </Column>
          <Column>
            <DetailsContainer>
              <Detail>{title}</Detail>
              <Detail>{abstract || 'N/A'}</Detail>
            </DetailsContainer>
          </Column>
        </SavedItemContent>
      </SavedItemContainer>
    );
  }
}

SavedItem.defaultProps = {
  thumbnailUrl: '',
  title: '',
  replaceables: [],
  channel: '',
  layer: '',
  timecodeIn: '00:00:00:00',
  timecodeDur: '00:00:00:00',
  abstract: '',
  onDoubleClick: () => {},
  onClick: () => {},
  selected: false
};

SavedItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  thumbnailUrl: PropTypes.string,
  title: PropTypes.string,
  abstract: PropTypes.string,
  onDoubleClick: PropTypes.func,
  onClick: PropTypes.func,
  selected: PropTypes.bool
};

export default SavedItem;



// WEBPACK FOOTER //
// ./app/components/SavedItems/SavedItem.js